import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import {
  LinkBtn,
  LinkWrapper,
} from 'app/pages/library/videos/videoList/components/SendAndShare';

import { MdClose } from 'react-icons/md';
import { OrganizationVideosTable } from './OrganizationVideosTable';
import { FullScreenModal } from 'lib/components/FullScreenModal';
import { useAuth } from 'lib/context';
import { Button } from 'react-covideo-common';
import { ModalOrganizationVideoForm } from './ModalOrganizationVideoForm';

const Title = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-feature-settings:
    'tnum' on,
    'lnum' on,
    'ss02' on;
  color: ${theme.palette.covideoBlue100};
`;

type Props = {
  handleModalClose: () => void;
  onCopy?: () => void;
};

export const ModalOrganizationVideos = ({
  handleModalClose,
  onCopy,
}: Props) => {
  const {
    userData: { isOrganizationAdmin },
  } = useAuth();
  const [showOrganizationVideoFormModal, setShowOrganizationVideoFormModal] =
    useState(false);
  return (
    <FullScreenModal
      headerLeft={
        <LinkWrapper>
          <LinkBtn onClick={handleModalClose}>
            <MdClose size='18' />
            <span>Close</span>
          </LinkBtn>
        </LinkWrapper>
      }
      headerCenter={<Title>Available OEM Videos</Title>}
      headerRight={
        isOrganizationAdmin && (
          <Button
            variant='primary'
            text='Add Video'
            onClick={() => setShowOrganizationVideoFormModal(true)}
          />
        )
      }
    >
      <OrganizationVideosTable
        handleModalClose={handleModalClose}
        onCopy={onCopy}
      />
      {showOrganizationVideoFormModal && (
        <ModalOrganizationVideoForm
          handleModalClose={() => setShowOrganizationVideoFormModal(false)}
        />
      )}
    </FullScreenModal>
  );
};
